<!-- @format -->
<script lang="ts">
  import Collapse from "~/components/fragment-sets/common/Collapse.svelte";
  import { filter_by_store } from "./store";
  export let offers: OrangeAds[];
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  export let request_store_key: StoresKey;
  const { T } = getStoresContext(request_store_key);
  function change(e: string) {
    $filter_by_store = e;
  }
  $: shops = [
    ...new Set(
      offers
        .map((i) => i.shop_name)
        .sort((a, b) =>
          a.localeCompare(b, undefined, {
            numeric: true,
            sensitivity: "base",
          }),
        ),
    ),
  ];
</script>

<div class="col-12 col-lg-4 mb-3">
  <Collapse open_by_default={false}>
    <button
      slot="open"
      class="py-2 d-flex w-100 me-2 justify-content-between purple-button fw-normal">
      {$filter_by_store ? $filter_by_store : $T`fob-all`}
      <i class="fas fa-chevron-up" />
    </button>
    <button
      slot="close"
      class="py-2 d-flex w-100 me-2 justify-content-between purple-button fw-normal">
      {$filter_by_store ? $filter_by_store : $T`fob-all`}
      <i class="fas fa-chevron-down" />
    </button>
    <div class="select">
      <button
        on:click={() => {
          change("");
        }}>
        {$T`show-all`}
      </button>
      {#each shops as shop}
        <button
          on:click={() => {
            change(shop);
          }}>{shop}</button>
      {/each}
    </div>
  </Collapse>
</div>

<style lang="scss">
  .select {
    background-color: #fff;
    margin-top: 8px;
    max-height: 300px;
    overflow: auto;
  }
  .select button {
    display: block;
    border: none;
    background-color: transparent;
    color: #000;
    text-align: left;
    width: 100%;
    padding: 0.5rem 1rem;
  }
  .select button:hover {
    background-color: var(--brandColor2);
    color: #fff
  }
</style>
